import {
  GETTING_CAMPAIGN_FAILED,
  GETTING_CAMPAIGNS_FAILED,
  CREATING_CAMPAIGN_FAILED,
  UPDATING_CAMPAIGN_FAILED,
  DELETING_CAMPAIGNS_FAILED
} from '../../store/campaign/actions';

import { GETTING_TEMPLATES_FAILED } from '../../store/template/actions';

import { goToButton, dismissButton } from '../../helpers/error/buttonBuilders';
import { CAMPAIGNS, CAMPAIGN } from '../UserMessaging/userMessageDomains';

const getFailedGettingAllTheDataContext = (plural = false) => ({
  userMessage: {
    instructions: `Failed getting all the data needed for the ${
      plural ? 'campaigns' : 'campaign'
    }`,
    buttons: [dismissButton()]
  }
});

const campaigns = {
  [CAMPAIGNS]: {
    [GETTING_CAMPAIGNS_FAILED]: {
      resource: 'campaign',
      userMessage: {
        instructions: 'Failed getting all campaigns',
        buttons: [dismissButton()]
      }
    },
    [GETTING_TEMPLATES_FAILED]: getFailedGettingAllTheDataContext(true)
  }
};

const campaign = {
  [CAMPAIGN]: {
    [GETTING_CAMPAIGN_FAILED]: {
      resource: 'campaign',
      userMessage: {
        buttons: [goToButton('OK', '/campaigns')]
      }
    },

    [UPDATING_CAMPAIGN_FAILED]: {
      resource: 'campaign',
      userMessage: {
        instructions: 'Could not save campaign, please try again',
        buttons: [dismissButton()]
      }
    },

    [DELETING_CAMPAIGNS_FAILED]: {
      resource: 'campaign',
      userMessage: {
        instructions: 'Could not delete campaign, please try again',
        buttons: [dismissButton()]
      }
    },

    [CREATING_CAMPAIGN_FAILED]: {
      resource: 'campaign',
      userMessage: {
        instructions: 'Could not save campaign. Please try again',
        buttons: [dismissButton()]
      }
    },

    [GETTING_TEMPLATES_FAILED]: getFailedGettingAllTheDataContext()
  }
};

export default { ...campaigns, ...campaign };
